<template>
    <v-dialog v-model="show" max-width="500">
        <v-card class="v-card--dialog v-card--dialog--sm">
            <v-btn fab color="transparent" @click="close" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            <div class="v-card--dialog__body">
                <div class="mb-10px mb-md-20px">
                    <h3 class="tit tit--xs">입력한 연락처로 {{value.amount}} 캐시를 보내시겠습니까?</h3>
                    <v-divider class="grey lighten-1 mt-10px"></v-divider>
                </div>
                <div>
                    <!-- <v-row class="row--x-small font-size-14 align-center">
                        <v-col cols="3">
                            받는사람 이름
                        </v-col>
                        <v-col cols="9">
                            {{value.receiver.name}}
                        </v-col>
                    </v-row>
                    <v-row class="row--x-small font-size-14 align-center">
                        <v-col cols="3">
                            아이디
                        </v-col>
                        <v-col cols="9">
                            {{value.receiver.username}}
                        </v-col>
                    </v-row> -->
                    <v-row class="row--x-small font-size-14 align-center">
                        <v-col cols="3">
                            연락처
                        </v-col>
                        <v-col cols="9">
                            {{value.receiver.phone}}
                        </v-col>
                    </v-row>
                    <v-row class="row--x-small font-size-14 align-center">
                        <v-col cols="3">
                            보내는 금액
                        </v-col>
                        <v-col cols="9">
                            {{value.amount}} 원
                        </v-col>
                    </v-row>
                    <v-row class="row--x-small font-size-14 align-center">
                        <v-col>
                            *정확한 연락처를 확인 후 보내시기 바랍니다. 
                        </v-col>
                    </v-row>
                </div>
            </div>
            <div class="v-card--dialog__foot">
                <v-row class="row--x-small">
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn @click="give" color="primary">확인</v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
import api from "@/api";
export default {
    props: {
        // gift: {
        //     type: Object
        // }
        value: {
            type: Object
        }
    },
    data(){
        return {
            show: false,
            me: null,
        }
    },
    methods: {
        async init(){
            let { me } = await api.v1.me.profile.get();
            this.me = me;
        },
        async give(){
            this.value.amount = this.value.amount.replaceAll(",","")
            await api.v1.me.gifts.post(this.value);
            alert("선물이 완료되었습니다");
            await this.init();
            this.$emit("init", this.me);
            this.$set(this.value, 'receiver', {})
            this.$set(this.value, 'amount', 0)
            this.close()
        },
        open(){
            this.show = true;
        },
        close(){
            this.show = false;
        }
    }
}
</script>